// Copyright (c) 2016 Deere & Company

import * as fetchService from '../../../shared/services/fetch';
import {handleError} from '../../../shared/services/error-handlers';

const basePath = '/api';

const reimbursedPercentageMinFacet = min =>
    typeof min === 'number' ? `&reimbursedPercentageMin=${min}` : '';

const reimbursedPercentageMaxFacet = max =>
    typeof max === 'number' ? `&reimbursedPercentageMax=${max}` : '';

const reimbursedAmountMinFacet = min =>
    typeof min === 'number' ? `&reimbursedAmountMin=${min}` : '';

const reimbursedAmountMaxFacet = max =>
    typeof max === 'number' ? `&reimbursedAmountMax=${max}` : '';

const issueDateStartFacet = start =>
    typeof start === 'number' ? `&issueDateStart=${start}` : '';

const issueDateEndFacet = end =>
    typeof end === 'number' ? `&issueDateEnd=${end}` : '';

const productFacet = productCode =>
    typeof productCode === 'string' ? `&product=${productCode}` : '';

const getClaimsForAuditFacetParams = facets => {

    const claimTypes = facets.selectedClaimTypes.reduce((acc, type) => `${acc}&claimType=${type.key}`, '');

    const reimbursedPercentageMin = reimbursedPercentageMinFacet(facets.reimbursedPercentage.min);
    const reimbursedPercentageMax = reimbursedPercentageMaxFacet(facets.reimbursedPercentage.max);

    const reimbursedAmountMin = reimbursedAmountMinFacet(facets.reimbursedAmount.min);
    const reimbursedAmountMax = reimbursedAmountMaxFacet(facets.reimbursedAmount.max);

    const issueDateStart = issueDateStartFacet(facets.dateIssued.from);
    const issueDateEnd = issueDateEndFacet(facets.dateIssued.to);

    const product = productFacet(facets.selectedProductCode);

    return `${claimTypes}${reimbursedPercentageMin}${reimbursedPercentageMax}${reimbursedAmountMin}${reimbursedAmountMax}${issueDateStart}${issueDateEnd}${product}`;

};

export async function getMachineStatusUpdates(payload) {

    const endPoint = (payload.export === 'EXCEL') ? `${basePath}/status-changes/collection?export=EXCEL&tcsm_flag=True` : `${basePath}/status-changes/collection?tcsm_flag=True`;

    const fetchOptions = {
        body: JSON.stringify(payload),
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, fetchOptions);

        return (payload.export === 'EXCEL') ? response : response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getAuditRecords(auditNumber) {

    const endPoint = `${basePath}/audit-recordings/${auditNumber}`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function postAuditRecords(audit) {

    const endPoint = `${basePath}/audit-recordings`;

    const fetchOptions = {
        body: JSON.stringify(audit),
        method: 'POST'
    };

    try {

        return await fetchService.fetch(endPoint, fetchOptions);

    } catch (error) {

        return handleError(error);

    }

}

export async function getSpaClaims(payload) {

    const endPoint = (payload.export === 'EXCEL') ? `${basePath}/claims-for-approval-summaries/collection?export=EXCEL` : `${basePath}/claims-for-approval-summaries/collection`;

    const fetchOptions = {
        body: JSON.stringify(payload),
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, fetchOptions);

        return (payload.export === 'EXCEL') ? response : response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getSpaClaim(claimNumber) {

    const endPoint = `${basePath}/claims-for-approval/${claimNumber}`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function updateSpaClaim(claimForApproval) {

    const endPoint = `${basePath}/claims-for-approval/${claimForApproval.claimNumber}`;

    const fetchOptions = {
        body: JSON.stringify(claimForApproval),
        method: 'PUT'
    };

    try {

        return await fetchService.fetch(endPoint, fetchOptions);

    } catch (error) {

        return handleError(error);

    }

}

export async function getPipCodeRequests(payload) {

    const endPoint = (payload.export === 'EXCEL') ? `${basePath}/pip-code/collection?export=EXCEL` : `${basePath}/pip-code/collection`;

    const fetchOptions = {
        body: JSON.stringify(payload),
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, fetchOptions);

        return (payload.export === 'EXCEL') ? response : response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getLaborRateChanges(selectedAccounts) {

    const endPoint = `${basePath}/labor-rates/collection`;

    const body = {
        accounts: selectedAccounts,
        getForTcsm: true
    };

    const fetchOptions = {
        body: JSON.stringify(body),
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, fetchOptions);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getClosingAccount(selectedAccounts) {

    const endPoint = `${basePath}/account/transfer/collection`;

    const body = {
        accounts: selectedAccounts
    };

    const fetchOptions = {

        body: JSON.stringify(body),
        cloudPreferred: true,
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, fetchOptions);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function putClosingAccount(closingAccount) {

    const endPoint = `${basePath}/account/transfer/`;

    const body = {
        ...closingAccount
    };

    const fetchOptions = {

        body: JSON.stringify(body),
        cloudPreferred: true,
        method: 'PUT'
    };

    try {

        const response = await fetchService.fetch(endPoint, fetchOptions);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function putDuplicatePinPlate(duplicatePinPlate) {

    const endPoint = `${basePath}/products/pin/plate/`;

    const body = {
        ...duplicatePinPlate
    };

    const fetchOptions = {

        body: JSON.stringify(body),
        cloudPreferred: true,
        method: 'PUT'
    };

    try {

        const response = await fetchService.fetch(endPoint, fetchOptions);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getDuplicatePinPlate(duplicatePinPlatePaylod) {

    const endPoint = `${basePath}/products/pin/plate/collection`;

    const fetchOptions = {

        body: JSON.stringify(duplicatePinPlatePaylod),
        cloudPreferred: true,
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, fetchOptions);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function updateMachineStatus(statusRequest) {

    const endPoint = `${basePath}/status-changes/${statusRequest.id}`;

    const fetchOptions = {
        body: JSON.stringify(statusRequest),
        method: 'PUT'
    };

    try {

        return await fetchService.fetch(endPoint, fetchOptions);

    } catch (error) {

        return handleError(error);

    }

}

export async function updatePipCodeRequest(pipCodeRequest) {

    const endPoint = `${basePath}/pip-code/${pipCodeRequest.transactionId}`;

    const fetchOptions = {
        body: JSON.stringify(pipCodeRequest),
        method: 'PUT'
    };

    try {

        return await fetchService.fetch(endPoint, fetchOptions);

    } catch (error) {

        return handleError(error);

    }

}

export async function getAudits(selectedAccounts) {

    const endPoint = `${basePath}/audits/collection`;

    const body = {
        accounts: selectedAccounts
    };

    const fetchOptions = {
        body: JSON.stringify(body),
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, fetchOptions);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function getAuditCount() {

    const endPoint = `${basePath}/audit-count`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function getPreparedAudit(auditNumber, accounts) {

    const queryString = accounts.join('&d=');

    const endPoint = `${basePath}/audit-preparations?auditNumber=${auditNumber}&d=${queryString}`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function getUnpreparedAudit(accounts) {

    const queryString = accounts.join('&d=');

    const endPoint = `${basePath}/audit-preparations?d=${queryString}`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function getClaimsForAudit(accounts, facets) {

    const d = accounts.join('&d=');

    const facetParams = getClaimsForAuditFacetParams(facets);

    const endPoint = `${basePath}/audit-claims?d=${d}${facetParams}`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function postAudit(audit) {

    const endPoint = `${basePath}/audit-preparations`;

    const fetchOptions = {
        body: JSON.stringify(audit),
        method: 'POST'
    };

    try {

        return await fetchService.fetch(endPoint, fetchOptions);

    } catch (error) {

        return handleError(error);

    }

}

export async function postSkipAudit(audit) {

    const endPoint = `${basePath}/audits`;

    const options = {
        body: JSON.stringify(audit),
        method: 'POST'
    };

    try {

        return await fetchService.fetch(endPoint, options);

    } catch (response) {

        return handleError(response);

    }

}

export async function getAdjustmentTypes() {

    const endPoint = `${basePath}/constants?id=PARTIAL_DEBIT`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getDebitTypes() {

    const endPoint = `${basePath}/constants?id=DEBIT_TYPE`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getDebit(claimNumber) {

    const endPoint = `${basePath}/debits/${claimNumber}`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function postDebit(debit) {

    const endPoint = `${basePath}/debits`;

    const fetchOptions = {
        body: JSON.stringify(debit),
        method: 'POST'
    };

    try {

        return await fetchService.fetch(endPoint, fetchOptions);

    } catch (error) {

        return handleError(error);

    }

}

export async function getProductHierarchy() {

    const endPoint = `${basePath}/product-hierarchy`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function postMassLaborRates(massLaborRate) {

    const endPoint = `${basePath}/labor-rates`;

    const fetchOptions = {
        body: JSON.stringify(massLaborRate),
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, fetchOptions);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getNewSystemSelectedClaims(fromDate, toDate, accounts) {

    const queryString = accounts.join('&d=');

    const endPoint = `${basePath}/audit-preparations?d=${queryString}&issueDateFrom=${fromDate}&issueDateTo=${toDate}`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function getTcsmSettings(userId) {

    const endPoint = `${basePath}/users/${userId}/tcsm`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function getAmountOfUseRequests(payload) {

    const endPoint = `${basePath}/products/measurement-readings/collection`;

    const fetchOptions = {
        body: JSON.stringify(payload),
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, fetchOptions);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function updateAmountOfUse(measurementReading) {

    const endPoint = `${basePath}/products/measurement-readings/${measurementReading.id}`;

    const fetchOptions = {
        body: JSON.stringify(measurementReading),
        method: 'PUT'
    };

    try {

        return await fetchService.fetch(endPoint, fetchOptions);

    } catch (error) {

        return handleError(error);

    }

}



// WEBPACK FOOTER //
// ./src/tcsm/shared/repositories/index.js